import React, {Component, Fragment} from "react";
import {translate} from "react-polyglot";
import {Col, Input, Row} from "reactstrap";
import styled from "styled-components";
import BasicSelect from "../fields/BasicSelect";
import BasicSlider from "../fields/BasicSlider";
import CustomCheckbox from "../fields/CheckboxField";
import FireRatingFilter from "../fields/FireRatingFilter";

const StyledHr = styled.hr`
  height: 0.25rem;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

interface IProps {
  primaryFilters: any[];
  handleValueChange: (filterId: string, value: string[]) => void;
}

class PrimaryFilterGroup extends Component<IProps & TranslateProps> {
  public render() {
    const {primaryFilters, handleValueChange, t} = this.props;
    const filters = primaryFilters
      .sort((a, b) => {
        return a.order < b.order ? 0 : 1;
      })
      .map((f: any, i: number) => {
        const {isPrimary, allowedValues, parameter, type, id, values} = f;

        if (!isPrimary) {
          return null;
        }

        switch (type) {
          case "fireRatingFilter":
            return (
              <Col className="pt-2 col-12" key={id}>
                <FireRatingFilter handleValueChanged={(e: any) => handleValueChange(id, e)}/>
                <StyledHr className="mb-0 mt-3 "/>
              </Col>
            );
          case "number":
            return (
              <Col className="pt-2 col-12" key={id}>

                <label htmlFor={parameter}>
                  {t(`parameters.${parameter}`)}
                </label>

                <Input
                  id={parameter}
                  type="number"
                  step={allowedValues.increment}
                  min={allowedValues.minValue}
                  max={allowedValues.maxValue}
                  value={values[0]}
                  onChange={(e: any) => handleValueChange(id, [e.target.value])}
                />
                <StyledHr className="mb-0 mt-3 "/>
              </Col>
            );
          case "dropdown":
            if (!Array.isArray(allowedValues)) {
              return null;
            }

            return (
              <Col key={id} className="pt-2 col-12">
                <BasicSelect
                  fieldName={parameter}
                  options={allowedValues}
                  handleSelect={(value: string) =>
                    handleValueChange(id, [value])
                  }
                  value={values[0]}
                />
                <StyledHr className="mb-0 mt-3 "/>
              </Col>
            );
          case "checkbox":
            if (!Array.isArray(allowedValues)) {
              return null;
            }

            return (
              <Col key={id} className="pt-2 col-12">
                <CustomCheckbox
                  fieldId={parameter}
                  fieldName={parameter}
                  options={allowedValues}
                  handleValueChange={(value: string[]) =>
                    handleValueChange(id, value)
                  }
                  checkedOption={values[0]}
                />
                <StyledHr className="mb-0 mt-3 "/>
              </Col>
            );
          case "slider":
            return (
              <Fragment>
                <BasicSlider
                  parameter={parameter}
                  allowedValues={allowedValues}
                  handleValueChange={handleValueChange}
                  id={id}
                  value={values[0]}
                  key={id}
                />
              </Fragment>
            );
          default:
            break;
        }
      });

    return (
      <Col className="pt-2">
        <Row>
          {filters}
        </Row>
      </Col>
    );
  }
}

export default translate()(PrimaryFilterGroup);
